module.exports = __webpack_public_path__ + "static/og_image-4aefbd00b1acb8a950fb7f7c48cd5718.png";